module.exports = __webpack_public_path__ + "static/img/logo_HT.fef28f0b.png";